import { useState } from "react";
import { Link } from 'react-router-dom'
import FormalitiesRequestsFilter from "components/formalities/helpers/FormalitiesRequestsFilter";
import FormalitiesRequestsList from "components/formalities/FormalitiesRequestsList";
export default function PageCustomerFormalities() {
  // -----------------------------
  // Filtres (source de vérité)
  // -----------------------------
  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  return (
    <>
      <div className="text-end mb-4">
        <Link to="/formalities/templates" className="btn btn-sm  btn-outline-primary rounded-pill">Introduire une nouvelle demande</Link>
        <hr />
      </div>
      {/* FILTER */}
      <div className="mb-3">
        <FormalitiesRequestsFilter
          search={search}
          onSearchChange={setSearch}
          monthFilter={monthFilter}
          onMonthChange={setMonthFilter}
          statusFilter={statusFilter}
          onStatusChange={setStatusFilter}
        />
      </div>
      {/* LIST */}
      <FormalitiesRequestsList
        filters={{
          search,
          month: monthFilter,
          status: statusFilter,
        }}
      />
    </>
  );
}
